import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TreeModule, TreeNodeSelectEvent } from 'primeng/tree';
import { first } from 'rxjs';

@Component({
  selector: 'app-move-folder-dialog',
  standalone: true,
  imports: [
    TreeModule,
    CommonModule,
    ButtonModule
  ],
  templateUrl: './move-folder-dialog.component.html',
  styleUrl: './move-folder-dialog.component.scss'
})
export class MoveFolderDialogComponent {
  dialogRef = inject(DynamicDialogRef<MoveFolderDialogComponent>)
  dialogConfigRef = inject(DynamicDialogConfig<MoveFolderDialogComponent>)

  treeView$ = this.dialogConfigRef.data.treeView$
  selected: TreeNode | undefined

  constructor() {
  }

  onNodeSelected(event: TreeNodeSelectEvent) {
    this.selected = event.node
  }

  close() {
    this.dialogRef.close()
  }

  move(){
    this.dialogRef.close(this.selected)
  }
}
